import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import propTypes from "prop-types";

ServiceCard.propTypes = {
	service: propTypes.shape({
		title: propTypes.string.isRequired,
		description: propTypes.string.isRequired,
		image: propTypes.string.isRequired,
		slug: propTypes.string.isRequired,
	}).isRequired,
	index: propTypes.number.isRequired,
};

function ServiceCard({ service, index }) {
	const location = useLocation();
	const isServicesPage = location.pathname === "/services";

	const cardVariants = {
		hidden: { opacity: 0, y: 50 },
		visible: (i) => ({
			opacity: 1,
			y: 0,
			transition: {
				delay: i * 0.1,
				duration: 0.6,
				ease: "easeOut",
			},
		}),
	};

	const overlayVariants = {
		initial: { opacity: 0.6 },
		hover: { opacity: 0.3 },
	};

	const contentVariants = {
		initial: { y: 20 },
		hover: { y: 0 },
	};

	return (
		<Link to={`/services/${service.slug}`}>
			<motion.div
				variants={cardVariants}
				initial="hidden"
				animate="visible"
				whileHover="hover"
				custom={index}
				className={`relative h-[20rem] flex flex-col py-12 px-4 md:py-12 md:px-12 justify-end bg-cover bg-center rounded-lg group overflow-hidden cursor-pointer ${
					isServicesPage ? "xl:w-[30rem] lg:w-[20rem]" : ""
				}`}
				style={{ backgroundImage: `url(${service.image})` }}
			>
				{/* Animated Overlay */}
				<motion.div
					variants={overlayVariants}
					initial="initial"
					animate="initial"
					className="absolute inset-0 bg-black"
				/>

				{/* Animated Content */}
				<motion.div
					variants={contentVariants}
					initial="initial"
					animate="initial"
					className="relative w-full font-GeneralSans text-white"
				>
					<motion.h2
						className="xl:lg:text-xl text-md font-semibold mb-4"
						initial={{ opacity: 0, y: 10 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ delay: 0.3, duration: 0.5 }}
					>
						{service.title}
					</motion.h2>
					<motion.p
						className="text-sm font-light"
						initial={{ opacity: 0, y: 10 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ delay: 0.4, duration: 0.5 }}
					>
						{service.description}
					</motion.p>
				</motion.div>
			</motion.div>
		</Link>
	);
}

export default ServiceCard;
